<template>
  <BaseWidget
    :class="['heroes-program-widget']"
    :loading="loading"
    :widget-options="widgetMenuOptions" 
    @refresh-data="refreshData(true)" 
    @custom-remove="removeWidget"
    v-on="$listeners"
  >
    <template v-slot:content>
      <portal to="dash-modal">
        <HeroesModal v-if="showModal" :promo-data="heroesStatus" :bonus="bonus" :promo-status="promoStatus" @close-modal="showModal = false" />
      </portal>
      <div class="heroes-content-wrap" :class="{ grace: isGrace }">
        <div class="title">{{ title }}</div>
        <div v-if="!isCancelled" class="award-wrap">
          <div class="description">
            <span>{{ $gettext('Earned') }}</span>
            <h3 class="pl-1 mt-1">{{ amountEarned }}</h3>
          </div>
          <div class="description">
            <span>{{ $gettext('Invites active') }}</span>
            <h3 class="pl-1 mt-1">{{ (heroesStatus.total_users_created) ? heroesStatus.total_users_created : 0 }}</h3>
          </div>
        </div>
        <div style="z-index: 10;">
          <GekkoButton 
            @click="showModal = true"
            :text="$gettext('Learn more')" 
            variant="white"
            class="w-100"
            size="sm"
          />
        </div>
        <AnimationItem v-if="heroesStatus && !isCancelled" class="anim-hero" :animation="{ animationData: heroAnimation.default }" :key="'anim_hero'" />
        <AnimationItem v-else class="anim-hero hero-facepalm" :animation="{ animationData: heroAnimationInactive.default }" :key="'anim_hero_wait'" />
      </div>
    </template>
  </BaseWidget>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import BaseWidget from "@/components/dashboard/widgets/BaseWidget"
import GekkoButton from '@/components/GekkoButton';
import AnimationItem from '@/components/dashboard/ui/AnimationItem.vue'
import * as heroAnimation from '@/css/animations/hero.json';
import * as heroAnimationInactive from '@/css/animations/hero-facepalm.json';
import HeroesModal from "@/components/dashboard/ui/HeroesModal.vue";

export default {
  name: 'heroes-program-widget',
  components: { BaseWidget, GekkoButton, AnimationItem, HeroesModal },
  props: {
    widget: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: true,
      title: '',
      subtitle: '',
      heroAnimation: heroAnimation,
      heroAnimationInactive: heroAnimationInactive,
      showModal: false,
      bonus: 20
    }
  },
  computed: {
    ...mapGetters({
      heroesStatus: 'dashboard/getHeroesStatus',
      extraConfig: 'dashboard/getExtraConfig'
    }),
    amountEarned () {
      let amount = '0,-'
      if (this.heroesStatus && this.heroesStatus.total_users_paying > 0) {
        amount = this.heroesStatus.total_users_paying * this.bonus
      }
      return '€' + amount
    },
    widgetMenuOptions () {
      if (this.loading) return []
      return [
        { name: this.$gettext('Remove From Dashboard'), icon: 'icon-remove', event: { name: 'custom-remove' } }
      ]
    },
    isCancelled () {
      if (this.heroesStatus.cancel_date === null) {
        return false;
      }
      return new Date(this.heroesStatus.cancel_date) < new Date();
    },
    isGrace () {
      if (this.heroesStatus.cancel_date === null) {
        return false;
      }
      return new Date(this.heroesStatus.cancel_date) >= new Date();
    },
    promoStatus () {
      let status = ''
      if (this.isCancelled) {
        status = 'cancel'
      }
      if (this.isGrace) {
        status = 'grace'
      }
      return status
    }
  },
  created () {
  },
  mounted () {
    this.refreshData()
  },
  methods: {
    ...mapActions({ 
      loadHeroesStatus: 'dashboard/loadHeroesStatus',
      updateExtraConfig: 'dashboard/updateExtraConfig'
    }),
    refreshData (forceRefresh = false) {
      if (forceRefresh) {
        this.getData()
      } else {
        this.getStoreData()
      }
    },
    getData () {
      this.loading = true
      this.loadHeroesStatus().then(() => {
        this.setupWidget()
        this.loading = false
      })
    },
    getStoreData () {
      this.setupWidget()
      this.loading = false
    },
    setupWidget () {
      this.title = ''
      if (this.heroesStatus) {
        if (!this.isCancelled) {
          if (this.isGrace) {
            this.title = this.$gettext('You are about to lose your hero cape')
          } else {
            this.title = this.$gettext('You are a Gekko Hero')
          }
        } else {
          this.title = this.$gettext('Hero code inactive')
        }
      }
    },
    removeWidget () {
      const new_extra_config = this.extraConfig
      new_extra_config.closed_heroes = true
      this.updateExtraConfig(new_extra_config)

      this.$emit('widget-event', { 'event': 'remove' })
      setTimeout(() => {
        this.$emit('widget-event', { 'event': 'update', 'target': 'company-profile' })
      }, 100);
    }
  },
}
</script>

<style lang="scss">
.widget-wrapper.heroes-program-widget {
  background: linear-gradient(40deg, $colorBlue, $colorBlue800);
  .heroes-content-wrap {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1; width: 100%;
    .title {
      font-size: 22px;
      line-height: 1;
    }
    &.grace {
      .title {
        font-size: 20px;
      }
    }
  }
  .ui-dashboard-menu-dropdown:not(.show) .widget-dropdown-toggle,
  .content {
    background: transparent;
    color: white;
    h3 { margin-top: 0; }
    .award-wrap {
      display: flex;
      margin-bottom: 1rem;
      z-index: 10;
      .description {
        font-size: 1rem;
        line-height: 1.3;
        text-align: center;
        white-space: nowrap;
        &:not(:last-child) { margin-right: 1rem; }
        > span { font-size: 14px; opacity: 0.7; line-height: 1; }
        .btn { line-height: 1.3; border: 0; text-decoration: underline; }
      }
    }
    .anim-hero {
      pointer-events: none;
      height: 100% !important;
      width: auto !important;
      margin: 0 auto;
      position: absolute;
      bottom: 0;
      right: 0;
      &.hero-wait { height: 120% !important }
      &.hero-facepalm { width: 100% !important; }
    }
  }
}
</style>
